import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import confetti from "canvas-confetti";
import "./JoinPremium.css";

const JoinPremium = () => {
  const navigate = useNavigate();
  const [isPremium, setIsPremium] = useState(false);
  const [showCongrats, setShowCongrats] = useState(false);

  useEffect(() => {
    const membership = localStorage.getItem("revoraMembership");
    if (membership === "Premium") setIsPremium(true);
  }, []);

  const handleJoin = () => {
    localStorage.setItem("revoraMembership", "Premium");
    setIsPremium(true);
    setShowCongrats(true);

    // 🎉 Golden Confetti effect
    confetti({
      particleCount: 200,
      spread: 80,
      origin: { y: 0.6 },
      colors: ["#d4af37", "#000", "#fff"],
    });

    setTimeout(() => {
      setShowCongrats(false);
      navigate("/account");
    }, 2500);
  };

  const handleCancel = () => {
    localStorage.setItem("revoraMembership", "Basic");
    setIsPremium(false);
  };

  return (
    <section className="join-premium">
      <div className="premium-card glass">
        {showCongrats && (
          <div className="congrats-popup">
            🎉 Congratulations, you’re now a Premium Revora Member! 🎉
          </div>
        )}

        {!isPremium ? (
          <>
            <h1>Revora Premium Membership</h1>
            <p className="premium-subtext">
              Unlock the next level of luxury, exclusivity, and personalization with Revora Premium.
            </p>

            <div className="benefits">
              <h2>Exclusive Benefits</h2>
              <ul>
                <li>✨ Priority access to limited edition car models</li>
                <li>🛠️ Early access to new customization tools</li>
                <li>🚗 Free luxury test drives every month</li>
                <li>🎁 Exclusive Revora Premium welcome kit</li>
                <li>👑 Personalized car concierge support</li>
              </ul>
            </div>

            <div className="pricing">
              <h2>Membership Plan</h2>
              <p><strong>₹999/month</strong> or <strong>₹8999/year</strong></p>
            </div>

            <button className="join-btn" onClick={handleJoin}>
              Upgrade to Premium
            </button>

            <p className="note">
              Already a Premium Member?{" "}
              <span onClick={() => navigate("/account")}>Go to your Account</span>
            </p>
          </>
        ) : (
          <>
            <h1>👑 You’re a Premium Member!</h1>
            <p className="premium-subtext">
              Enjoy your exclusive Revora privileges. You can manage or cancel your membership anytime.
            </p>

            <div className="benefits">
              <h2>Your Premium Benefits</h2>
              <ul>
                <li>🚗 Unlimited luxury test drives</li>
                <li>🛠️ Advanced car customization tools</li>
                <li>🎁 Premium rewards and early previews</li>
              </ul>
            </div>

            <button className="cancel-btn" onClick={handleCancel}>
              Cancel Membership
            </button>

            <p className="note">
              Want to explore your perks?{" "}
              <span onClick={() => navigate("/account")}>Go to your Account</span>
            </p>
          </>
        )}
      </div>
    </section>
  );
};

export default JoinPremium;
